import { getApiClient } from './ApiService'
import config from '../Config'

/* Personal topics ("Moje teme"). API guide: pres repo, docs/USER_TOPICS_API.md.
   Every call resolves to { isOk, status, data, message }; `message` is the
   API's own (Bosnian) error text when there is one, safe to show as-is. */

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` })

// Cloudflare caches the whole site for 60 s keyed by URL only (ignoring the
// Authorization header), so a personal GET could return someone else's data or
// a list from before the user's last change. The API answers /api/me with
// "no-store"; this unique parameter keeps it fresh even if a cache ignores that.
const fresh = () => ({ _: Date.now() })

const request = async (fn) => {
  try {
    const response = await fn()
    return { isOk: true, status: response.status, data: response.data }
  } catch (error) {
    if (config.IS_DEV) console.log('MY TOPICS ERROR: ', error.response)
    return {
      isOk: false,
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.response?.data?.error ?? 'Došlo je do greške. Pokušajte ponovo.',
    }
  }
}

const createProfile = () => request(() => getApiClient().post('/me', {}))

const getMyTopics = (token) =>
  request(() => getApiClient(authHeaders(token)).get('/me/topics', { params: fresh() }))

// body: { topic_id } to follow an existing topic, or { keywords } for own keywords.
// The web has no push device, so personal pushes stay off for web-made topics.
const addMyTopic = (token, body) =>
  request(() => getApiClient(authHeaders(token)).post('/me/topics', { notify: false, ...body }))

const deleteMyTopic = (token, id) =>
  request(() => getApiClient(authHeaders(token)).delete(`/me/topics/${id}`))

const previewKeywords = (keywords) =>
  request(() => getApiClient().get('/topics/preview', { params: { keywords } }))

const getMyNews = (token, { page = 1, perPage = 20, topicId } = {}) =>
  request(() =>
    getApiClient(authHeaders(token)).get('/me/news', {
      params: { page, per_page: perPage, ...(topicId ? { topic: topicId } : {}), ...fresh() },
    })
  )

export const myTopicsService = {
  createProfile,
  getMyTopics,
  addMyTopic,
  deleteMyTopic,
  previewKeywords,
  getMyNews,
}
